import { BRAND, waLink, WA_MSG } from "../data/content";
import { Chapter, Reveal, useTitle } from "../components/shared";
import { WhatsAppIcon } from "../components/Navbar";
import EnquireForm from "../components/EnquireForm";

export default function Contact() {
  useTitle("Contact Us | The Big Wedd — Plan My Wedding");
  return (
    <main className="bg-ivory pt-32 pb-24 md:pt-40 md:pb-32" data-testid="contact-page">
      <div className="mx-auto grid max-w-7xl gap-16 px-6 md:grid-cols-12 md:px-12">
        <div className="md:col-span-5">
          <Chapter num="—" title="Contact Us" />
          <Reveal delay={0.1}>
            <h1 className="mt-6 font-serif text-5xl md:text-6xl leading-[1.02] text-emerald">
              Let's create<br /><span className="italic text-gold-text">your big day.</span>
            </h1>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-md text-sm md:text-base leading-relaxed text-stone2">
              Tell us your vision, your destination and your dream wedding. Let's start planning something unforgettable.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-10 space-y-5 border-t border-gold/20 pt-8 text-sm">
              <p className="flex flex-col gap-1" data-testid="contact-phone">
                <span className="text-[10px] uppercase tracking-[0.25em] text-gold-text">Phone / WhatsApp</span>
                <span className="text-stone2">{BRAND.phone}</span>
              </p>
              <p className="flex flex-col gap-1" data-testid="contact-email">
                <span className="text-[10px] uppercase tracking-[0.25em] text-gold-text">Email</span>
                <span className="text-stone2">{BRAND.email}</span>
              </p>
              <p className="flex flex-col gap-1" data-testid="contact-locations">
                <span className="text-[10px] uppercase tracking-[0.25em] text-gold-text">Locations</span>
                <span className="text-stone2">{BRAND.locations.join("  ·  ")} — & destinations across India & abroad</span>
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.4}>
            <a
              href={waLink(WA_MSG)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-cta"
              className="mt-10 inline-flex items-center gap-3 rounded-full bg-emerald px-8 py-4 text-[11px] font-medium uppercase tracking-[0.22em] text-ivory transition-all duration-500 hover:bg-gold hover:text-ink"
            >
              <WhatsAppIcon className="h-4 w-4" /> Chat on WhatsApp
            </a>
          </Reveal>
        </div>

        <div className="md:col-span-7">
          <Reveal delay={0.2}>
            <div className="border border-gold/25 bg-white/70 p-7 md:p-10" data-testid="wedding-inquiry-form">
              <p className="text-[11px] uppercase tracking-[0.3em] text-gold-text">Plan My Wedding</p>
              <h2 className="mt-3 font-serif text-3xl md:text-4xl text-emerald">Tell us about your celebration</h2>
              <div className="mt-8">
                <EnquireForm />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </main>
  );
}
